import Clients from './Clients.view';

export default Clients;
